// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"154":"f27f22c7","772":"de6d56de","818":"68b929dc","917":"86af48cc","991":"89be19ef"}[chunkId] + ".chunk.css";
};